'use client';

import React from 'react';
import Footer from 'components/commercetools-ui/organisms/footer';
import { TasticProps } from '../types';
import { AmplienceFooterProps } from 'components/amplience/footer';

interface Props {
  dataSource: {
    dataSource: AmplienceFooterProps;
  };
}

const FooterTastic = ({ data }: TasticProps<Props>) => {
  return <Footer data={data?.dataSource?.dataSource} />;
};

export default FooterTastic;
